/** Removes double quotes from a measure name. */
export const sanitizeFieldName = (name: string) => {
  return name.replace(/"/g, "");
};
